export function configSetMomentTimeZone(moment, rnLocaleCookieProvider, angularMomentConfig, $injector) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  // Allow for configuring a bypass for setting the time zone.
  // This is not recommended but was requested.
  // Before configuring the app module, configure like this,
  // angular.module('gazelle.components.l10n').constant('$gzL10nConfig', { userTimeZone: false });
  if ($injector.has('$gzL10nConfig')) {
    let $gzL10nConfig = $injector.get('$gzL10nConfig');
    if ($gzL10nConfig.userTimeZone === false) {
      return;
    }
  }

  // Look to local preferences for user's preferred time zone
  let preferredTz = getTimeZone(rnLocaleCookieProvider.getTimeZone());

  // Can't call amMoment here, so call moment directly.
  // Will still call amMoment above because of eventing.
  // Leveraged from https://github.com/urish/angular-moment/blob/master/angular-moment.js#L382
  angularMomentConfig.timezone = preferredTz;
  if (moment.tz && moment.tz.setDefault) {
    moment.tz.setDefault(preferredTz);
  }
}

/**
 * Sets the angular moment time zone when the timezone is changed
 * by listening for rhino preference changes.
 */
export function runSetMomentTimeZone($rootScope, rnPreferences, amMoment, angularMomentConfig, $injector) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  // Allow for configuring a bypass for setting the time zone.
  // This is not recommended but was requested.
  // Before configuring the app module, configure like this,
  // angular.module('gazelle.components.l10n').constant('$gzL10nConfig', { userTimeZone: false });
  if ($injector.has('$gzL10nConfig')) {
    let $gzL10nConfig = $injector.get('$gzL10nConfig');
    if ($gzL10nConfig.userTimeZone === false) {
      return;
    }
  }

  rnPreferences.getAll().then(prefs => changeTimeZone(prefs));

  $rootScope.$on('rnPreferencesUpdated', (events, prefs) => changeTimeZone(prefs));

  /**
   * Change angular moment time zone based on rhino preferences.
   * @param prefs rhino preferences
   * @param prefs.general general preferences
   * @param prefs.general.timeZone time zone preference
   */
  function changeTimeZone(prefs) {
    let timeZonePref = _.get(prefs, 'general.timeZone');
    let preferredTz = getTimeZone(timeZonePref);
    if (angularMomentConfig.timezone !== preferredTz) {
      amMoment.changeTimezone(preferredTz);
    }
  }
}

function getTimeZone(timeZonePref) {
  if (timeZonePref) {
    let tzParts = timeZonePref.split(/\s+/);
    // support old time zone preference format with UTC offset in front.
    if(tzParts.length > 1) {
      return tzParts[1];
    }
    return tzParts[0];
  }
  return null;
}
